<template>
  <div class="notice-card-wrapper" v-if="ismarqueue">
    <div class="header">
      <div class="title">
        <!-- 系统公告 -->
        <div class="message">
          <div class="inner-container">
            <span :class="[isH5 ? 'msg-min' : 'msg']" v-html="notice"></span
            ><span @click="close" class="close el-icon-close"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemNotice",
  props: {
    isH5: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      notice: "",
      time: null,
      ShowNotice: true
    };
  },
  computed: {
    ...mapState({
      NoticeMessage: state => state.NoticeMessage,
      ismarqueue: state => state.ismarqueue
    })
  },
  created() {
    this.NoticeMessage.noticeInfo.forEach(item => {
      if (item.noticeType == 0) {
        this.notice = item.noticeContent;
      }
    });

    // this.notice += this.notice;
    // this.time = setInterval(() => {
    //   let start = this.notice.slice(0, 1);
    //   let end = this.notice.slice(1);
    //   this.notice = end + start;
    // }, 400);
  },
  methods: {
    close() {
      this.$store.commit("setState", {
        ismarqueue: false
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.time);
    this.time = null;
  }
};
</script>

<style lang="less" scoped>
.notice-card-wrapper {
  position: fixed;
  background: #ffffb9;
  left: 0px;
  top: 68px;
  z-index: 58;
  font-size: 12px;
  width: 100%;
  padding: 0 10px;
}
.mobile {
  .notice-card-wrapper {
    top: 60px;
    .close {
      top: 0px;
      font-size: 16px;
    }
  }
}
.inner-container {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  height: 30px;
  line-height: 30px;
  width: 100%;
  .close {
    position: absolute;
    width: 30px;
    text-align: center;
    top: 10px;
    cursor: pointer;
    z-index: 4;
    right: 0px;
  }
  .msg {
    animation: myMove 20s linear infinite; // 重点，定义动画
    display: inline-block;
    // width: 100%;
    position: relative;
    z-index: 2;
  }
  .msg-min {
    animation: minMove 10s linear infinite; // 重点，定义动画
    display: inline-block;
    // width: 100%;
    position: relative;
    z-index: 2;
  }
}
@keyframes myMove {
  0% {
    // 710
    transform: translateX(500px);
  }
  100% {
    transform: translateX(-100%);
  }
}
@keyframes minMove {
  0% {
    // 360
    transform: translateX(200px);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
